<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-8 col-xl-5">
                        <div class="font-weight-bold body-1">
                            Editar rol
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="8" xl="5">
                        <v-form ref="form" @submit.prevent="save">
                            <rol-form ref="RolForm" :values="form" @save="save" :serverErrors="serverErrors"></rol-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="8" xl="5" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../../helpers/Utils';
import RolForm from "./Form.vue";
import permissions from "./permission";
// import modules from './modules';
export default {
    components: {
        'rol-form': RolForm,
    },
	data(){
		return {
            loading: false,
            id: this.$route.params.id,
            serverErrors: {},
            form: {
                name: "",
                permissions: permissions,
                    
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Roles",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.init();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index(){
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.rol.get(this.id)
                .then((resp) => {
                    // let permi = [];
                    for (const property in resp.data.permissions) {
                        if(resp.data.permissions[property] instanceof Array)
                            resp.data.permissions[property] = {
                                create:false,
                                show:false,
                                update:false,
                                delete:false
                            };
                    }
                    //console.log(resp.data.permissions)
                    this.form.name = resp.data.name;
                    this.form.permissions = {...permissions, ...resp.data.permissions};
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        init()
        {
            for (const property in this.form.permissions) {
                this.form.permissions[property] = {
                    create:false,
                    show:false,
                    update:false,
                    delete:false
                };
            }
        },
        save(){
            
            console.log(this.form);
            this.prepareRequest(this.form);
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.rol.update(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Roles'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));
            data.permissions.admin = false;
            // data.permissions['payslip'].create = false;
            // data.permissions['payslip'].delete = false;
            // data.permissions['payslip_reports'].create = false;
            // data.permissions['payslip_reports'].delete = false;
            // data.permissions['payslip_reports'].update = false;
        //    for (const property in data.permissions) {

        //     //    if(property == 'payslip' || property == "payroll_payments"){
        //     //         if(data.permissions['payslip'].show || data.permissions['payroll_payments'].show)
        //     //             data.permissions['catalogs'].businessAll = true;
        //     //     }

        //     //     if(property == 'payroll_payments'){
        //     //         if(data.permissions['payroll_payments'].create == true){
        //     //             data.permissions['payroll_payments'].save = true;
        //     //         }else{
        //     //             data.permissions['payroll_payments'].save = false;
        //     //         }
        //     //         delete data.permissions['payroll_payments'].create;
        //     //     }
               
        //     }
            console.log(data);
            return data;
        }
    },
}
</script>

<style>

</style>